export const toPercent = (value: number, max: number) => {
  if (max === 0) return 100
  return Math.round(Math.min(value / max, 1) * 100)
}
